/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Export_Flag_RequiredInputs */

const cs_portals_export_flag_required = /** @type {(inputs: Portals_Export_Flag_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív zapněte Export na portály u nemovitosti, než povolíte konkrétní portál.`)
};

const en_portals_export_flag_required = /** @type {(inputs: Portals_Export_Flag_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on Export to portals on the listing before enabling a portal.`)
};

/**
* | output |
* | --- |
* | "Turn on Export to portals on the listing before enabling a portal." |
*
* @param {Portals_Export_Flag_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_export_flag_required = /** @type {((inputs?: Portals_Export_Flag_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Export_Flag_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_export_flag_required(inputs)
	return cs_portals_export_flag_required(inputs)
});